module.exports = __webpack_public_path__ + "static/media/gryphon-house-map-base.7dea16a3.png";